import React from 'react';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import Footer from '../components/layout/footer';
import cibfInfo from '../assets/icons/cibfInfo.svg';
import './info.css';
import InfoTimeline from '../components/common/infoTimeline';

const Info = () => {
    return ( <>
    <ScrollHideHeader />
    <main>
        <div className="bgDecor"></div>
        <section className="infoHero">
            <div className="infoHeroCont">
                <h1>Fair Information</h1>
                <h4>The Cairo International Book Fair returns for its 58th edition in 2027, welcoming millions of visitors to one of the largest and most influential cultural events in the Arab world.</h4>
            </div>
            <img className='displayFlex' src={cibfInfo} alt="Cairo International Book Fair logo" />
        </section>
        <InfoTimeline />
        <Footer />
    </main>
    </> );
}
 
export default Info;